<!-- Avatar com foto -->
<div *ngIf="getPhoto()"
     class="overflow-hidden flex-shrink-0 shadow-sm"
     [ngClass]="[getSizeClasses(), getRoundedClass()]">
    <img [src]="getPhoto()"
         [alt]="getName()"
         class="w-full h-full object-cover"
         (error)="onImageError()">
</div>

<!-- Avatar com iniciais (fallback) -->
<div *ngIf="!getPhoto()"
     class="flex items-center justify-center font-semibold flex-shrink-0 shadow-sm"
     [ngClass]="[getSizeClasses(), getRoundedClass(), getGenderClasses()]">
    {{ getInitials() }}
</div>
